var F = Object.defineProperty, G = Object.defineProperties;
var q = Object.getOwnPropertyDescriptors;
var x = Object.getOwnPropertySymbols;
var D = Object.prototype.hasOwnProperty, H = Object.prototype.propertyIsEnumerable;
var B = (n, r, a) => r in n ? F(n, r, { enumerable: !0, configurable: !0, writable: !0, value: a }) : n[r] = a, I = (n, r) => {
  for (var a in r || (r = {}))
    D.call(r, a) && B(n, a, r[a]);
  if (x)
    for (var a of x(r))
      H.call(r, a) && B(n, a, r[a]);
  return n;
}, S = (n, r) => G(n, q(r));
var $ = (n, r, a) => new Promise((f, m) => {
  var p = (o) => {
    try {
      u(a.next(o));
    } catch (d) {
      m(d);
    }
  }, s = (o) => {
    try {
      u(a.throw(o));
    } catch (d) {
      m(d);
    }
  }, u = (o) => o.done ? f(o.value) : Promise.resolve(o.value).then(p, s);
  u((a = a.apply(n, r)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getGetBrandListByOrgMarketManageRight as J } from "../../request/designordercenter/internal/customerOrderCommon/getBrandListByOrgMarketManageRight/get.js";
import Q from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import A from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/checkbox/src/Checkbox.js";
import W from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/checkbox/src/CheckboxGroup.js";
import X from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
import { defineComponent as Y, useTemplateRef as Z, computed as w, openBlock as g, createElementBlock as _, createElementVNode as y, createVNode as v, withCtx as c, createTextVNode as k, Fragment as N, renderList as V, createBlock as ee } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as h, unref as i } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import te from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import j from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
const le = { class: "tw:py-2.5 tw:border-b tw:border-[#ebeef5] tw:mb-2.5" }, ae = { class: "tw:max-h-[400px] tw:overflow-y-auto" }, re = { class: "tw:flex tw:flex-wrap tw:px-2.5" }, oe = { class: "tw:flex tw:justify-end tw:gap-3" }, ye = /* @__PURE__ */ Y({
  __name: "brandCategorySelector.ce",
  setup(n, { expose: r }) {
    const a = Z("brandCategoryContainer"), f = h(!1), m = h(!1), p = h([]), s = h([]);
    let u = null, o = null;
    const d = w(() => p.value.map((l) => l.key)), E = w(() => d.value.length > 0 && s.value.length === d.value.length), L = w(() => {
      const l = s.value.length;
      return l > 0 && l < d.value.length;
    }), M = w(() => {
      const l = {};
      return p.value.forEach((e) => {
        l[e.brand] || (l[e.brand] = {
          brand: e.brand,
          brandName: e.brandName,
          items: []
        }), l[e.brand].items.push(e);
      }), Object.values(l);
    });
    function P(l) {
      l ? s.value = [...d.value] : s.value = [];
    }
    function U(l) {
      return $(this, null, function* () {
        p.value = [], s.value = [], f.value = !0, m.value = !0;
        try {
          const e = yield J({
            orgId: l.orgId
          });
          e && Array.isArray(e) && (p.value = e.filter((t) => t.category !== "category_zhuangxiu").map((t) => S(I({}, t), {
            key: `${t.brand}-${t.category}|${t.brandName}-${t.categoryName}`
          })), l.selectedItems && l.selectedItems.length && (s.value = l.selectedItems.map((t) => t.key)));
        } catch (e) {
          console.error("获取品牌品类数据失败:", e);
        } finally {
          m.value = !1;
        }
        return new Promise((e, t) => {
          u = e, o = t;
        });
      });
    }
    function z() {
      f.value = !1;
      const l = s.value.map((e) => {
        const [t, b] = e.split("|"), [K, O] = t.split("-"), [R, T] = b.split("-");
        return {
          brand: K,
          category: O,
          brandName: R,
          categoryName: T,
          key: e
        };
      });
      u && (u(l), u = null, o = null);
    }
    function C() {
      f.value = !1, o && (o("cancel"), u = null, o = null);
    }
    return r({ open: U }), (l, e) => (g(), _(N, null, [
      y("div", {
        ref_key: "brandCategoryContainer",
        ref: a
      }, null, 512),
      v(i(X), {
        show: f.value,
        "onUpdate:show": e[1] || (e[1] = (t) => f.value = t),
        "mask-closable": !1,
        "z-index": 9999,
        to: a.value || "body"
      }, {
        default: c(() => [
          v(i(te), { show: m.value }, {
            default: c(() => [
              v(i(Q), {
                class: "tw:w-3/4",
                title: "品牌品类选择",
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: C
              }, {
                footer: c(() => [
                  y("div", oe, [
                    v(i(j), { onClick: C }, {
                      default: c(() => e[3] || (e[3] = [
                        k("取消", -1)
                      ])),
                      _: 1,
                      __: [3]
                    }),
                    v(i(j), {
                      type: "primary",
                      disabled: !s.value.length,
                      onClick: z
                    }, {
                      default: c(() => e[4] || (e[4] = [
                        k(" 确定 ", -1)
                      ])),
                      _: 1,
                      __: [4]
                    }, 8, ["disabled"])
                  ])
                ]),
                default: c(() => [
                  y("div", null, [
                    y("div", le, [
                      v(i(A), {
                        checked: E.value,
                        indeterminate: L.value,
                        "onUpdate:checked": P
                      }, {
                        default: c(() => e[2] || (e[2] = [
                          k(" 全选 ", -1)
                        ])),
                        _: 1,
                        __: [2]
                      }, 8, ["checked", "indeterminate"])
                    ]),
                    y("div", ae, [
                      v(i(W), {
                        value: s.value,
                        "onUpdate:value": e[0] || (e[0] = (t) => s.value = t)
                      }, {
                        default: c(() => [
                          (g(!0), _(N, null, V(M.value, (t) => (g(), _("div", {
                            key: t.brand,
                            class: "tw:py-2 tw:bg-[#f5f7fa] tw:mb-2 tw:overflow-auto"
                          }, [
                            y("div", re, [
                              (g(!0), _(N, null, V(t.items, (b) => (g(), ee(i(A), {
                                key: b.key,
                                value: b.key,
                                label: `${b.brandName}-${b.categoryName}`,
                                class: "tw:basis-1/4 tw:m-0 tw:py-1.5"
                              }, null, 8, ["value", "label"]))), 128))
                            ])
                          ]))), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  ye as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/brand-category-selector/brandCategorySelector.ce.vue.js
// module id = 866
// module chunks = 67